import { render, staticRenderFns } from "./CategoriaSelect.vue?vue&type=template&id=4fca89f1"
import script from "./CategoriaSelect.vue?vue&type=script&lang=js"
export * from "./CategoriaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports